@let tableName = this.tableName();
@let inside = this.inside();
@let logo = this.logo();

<ng-container coreActivitySection="Header">
  <app-button-back
    class="back"
    [inside]="inside"
    (click)="backButtonClick.emit($event)"
    [routerLink]="backButtonRouterLink()"
    [coreUserActivityClickTracking]="backButtonUserActivity()"
  />

  @if (logo) {
    <img class="logo" src="images/logo.svg" width="167" height="54" alt="logo"/>
  }

  <div class="table">
    {{ tableName }}
  </div>
</ng-container>
